import React from 'react';
import { motion } from 'framer-motion';
import { Coins, Wallet, UserMinus, ShieldCheck } from 'lucide-react';
import { WaitlistCTA } from '../WaitlistCTA';
export function CreatorHero() {
  const stats = [{
    icon: Coins,
    text: 'Every qualifying post earns 10,000 Giga credits'
  }, {
    icon: Wallet,
    text: "Cash tiers unlock above each platform's threshold"
  }, {
    icon: UserMinus,
    text: 'No follower minimum'
  }, {
    icon: ShieldCheck,
    text: 'No approvals'
  }];
  return <section className="py-20 md:py-28 px-6 md:px-8 max-w-7xl mx-auto" data-id="element-2236" data-mp="z3yzj97jwfbb">
      <div className="bg-[#2B211A] rounded-[2.5rem] md:rounded-[3rem] p-8 md:p-16 lg:p-24 flex flex-col items-center text-center relative overflow-hidden shadow-2xl" data-id="element-2237" data-mp="lc28l8hmcbgi">
        <div className="absolute inset-0 dark-grid opacity-50" data-id="element-2238" data-mp="q9asbdif0njv" />

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="relative z-10 flex flex-col items-center mb-8" data-id="element-2239" data-mp="1e0ga3y7x1pwt">
          
          <div className="inline-flex items-center justify-center px-4 py-1.5 rounded-full border border-white/20 bg-white/5 backdrop-blur-sm text-white/90 text-xs font-medium mb-4" data-id="element-2240" data-mp="21xwfmgkrmuc1">
            <span className="text-[#EA580C] font-bold mr-1" data-id="element-2241" data-mp="2brd7hf1cdzd2">Early access</span>{' '}
            | Available in select regions. Check the FAQ ↓
          </div>
          <p className="text-white/60 text-sm font-medium" data-id="element-2242" data-mp="2lngjdclzxcd7">
            Hundreds of creators already paid out
          </p>
        </motion.div>

        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.1
      }} className="relative z-10 font-title font-bold text-5xl md:text-7xl lg:text-8xl tracking-tight leading-[1.05] text-white mb-6" data-id="element-2243" data-mp="2goltjqpm2njl">
          
          Giga does the work.
          <br data-id="element-2244" data-mp="vcc009kow5cu" />
          <span className="text-[#EA580C]" data-id="element-2245" data-mp="vcu4tulf3rwd">You take the screenshot.</span>
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="relative z-10 max-w-2xl text-lg md:text-xl text-white/80 leading-relaxed mb-10 font-medium" data-id="element-2246" data-mp="2vetmvp3qzd6z">
          
          The report's built. The analysis ran. The automation shipped.
          Screenshot it, post it on LinkedIn, X, Instagram, YouTube, or TikTok,
          and earn up to{' '}
          <span className="text-white font-semibold" data-id="element-2247" data-mp="3jaz1g1o51d1s">$10,000</span>. Choose
          credits for{' '}
          <span className="text-[#EA580C] font-semibold" data-id="element-2248" data-mp="3o27d74cxxai4">50% more</span>.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.3
      }} className="relative z-10 flex flex-col sm:flex-row items-center gap-4 mb-20 w-full sm:w-auto" data-id="element-2249" data-mp="3t1tq1couwoqe">
          
          <WaitlistCTA className="w-full sm:w-auto px-8 py-4 bg-[#EA580C] text-white rounded-full font-bold text-lg hover:bg-[#C2410C] transition-colors shadow-lg" data-id="element-2250" data-mp="1qf5745a3vblm">
            Start Earning
          </WaitlistCTA>
          <a href="#how-it-works" className="w-full sm:w-auto px-8 py-4 bg-transparent border border-white/20 text-white rounded-full font-bold text-lg hover:bg-white/5 transition-colors" data-id="element-2251" data-mp="1hf8btkt7nehl">
            
            See How It Works
          </a>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.5
      }} className="relative z-10 w-full grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 pt-12 border-t border-white/10" data-id="element-2252" data-mp="2541ctvoowcj2">
          
          {stats.map((stat, i) => {
          const Icon = stat.icon;
          return <div key={i} className="flex flex-col items-center text-center space-y-4 p-6 rounded-2xl bg-white/5 border border-white/10 hover:bg-white/10 transition-colors" data-id="element-2253" data-mp="2o2x694sq4mvu" data-mpi={i}>
                
                <div className="w-14 h-14 rounded-2xl bg-white/10 flex items-center justify-center" data-id="element-2254" data-mp="2cm7n7lt09mas">
                  <Icon className="w-6 h-6 text-[#EA580C]" strokeWidth={2} data-id="element-2255" data-mp="1ympsyqwxxgu1" />
                </div>
                <p className="text-sm text-white/80 font-medium leading-relaxed" data-id="element-2256" data-mp="23lj4idso2xrk">
                  {stat.text}
                </p>
              </div>;
        })}
        </motion.div>
      </div>
    </section>;
}